import { LI, P, UL } from "../../../../AbstractElements";
import { recommendedByFriend, bySocialMedia } from "../../../../Constant";

const DeviceList = ({percentages}) => {
  const [percentFromFriend, percentFromSocialMedia] = percentages;
  
  return (
    <UL attrUL={{ className: "simple-list d-flex" }}>
      <LI>
        <P attrPara={{ className: "f-w-600 font-primary f-12" }}>{recommendedByFriend}</P>
        <span className="f-w-700">{percentFromFriend}%</span>
      </LI>
      <LI>
        <P attrPara={{ className: "f-w-600 font-primary f-12" }}>{bySocialMedia} </P>
        <span className="f-w-700">{percentFromSocialMedia}%</span>
      </LI>
    </UL>
  );
};

export default DeviceList;
